import React from 'react';
import Skeleton from 'flow/components/ui-components/Skeleton';
import { twMerge } from 'tailwind-merge';

type MessagePostSkeletonProp = {
    count?: number;
    isGrid?: boolean;
    isLarge?: boolean;
    className?: string;
};

const GenericSkeleton = ({ isLarge = false, isGrid = false }) => (
    <div className={twMerge('flex gap-x-3 p-3', isGrid ? 'flex-col' : '')}>
        <div className="w-full rounded-sm bg-gray-200 shadow-lg">
            <div>
                <div className="flex flex-col gap-y-6 bg-gray-300 p-6" />

                <div className="flex w-full flex-row gap-3 bg-gray-100 p-4">
                    <Skeleton.Avatar />

                    <div className="w-full">
                        <Skeleton.Title className="mb-3" />

                        <Skeleton.Paragraph isLarge={isLarge} />
                    </div>
                </div>
            </div>
        </div>
    </div>
);

const MessagesPostSkeleton = ({
    isGrid,
    count = 4,
    isLarge = false,
    className = '',
}: MessagePostSkeletonProp) => (
    <div
        className={twMerge(
            'animate-fade w-full max-w-2xl text-gray-200',
            className,
            isGrid ? 'grid grid-cols-2 gap-3' : '',
        )}
    >
        {Array.from({ length: count }).map((_, index) => (
            <GenericSkeleton key={index} isLarge={isLarge} isGrid={isGrid} />
        ))}
    </div>
);

export default MessagesPostSkeleton;
